module.exports = __webpack_public_path__ + "static/media/shipping.cb33635d.jpg";